export default __webpack_public_path__ + "static/bronze-17dc5ece83e97604dad21c60c52f4375.jpg";